module.exports = __webpack_public_path__ + "img/JQ.bef123fb.jpg";